// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// services
import { ObjectUtil, PartListService } from "@/services";

// types
import { IQuickOrdersContext } from "../../QuickOrders.types";

export default Vue.extend({
  name: "DeleteListConfirmation",
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  methods: {
    async deleteList() {
      try {

        const context = this.context as IQuickOrdersContext;

        const params = {
          accountId: context.accountId,
          userId: context.user.UserId,
          partListId: Number(context.partListId),
        };

        await PartListService.DeletePartList(params);

        this.$store.commit("pushTimedMessage", {
          header: "List deleted",
          IsError: false,
          seconds: 3,
        });

        this.$router.push({ name: "QuickOrders" });
      } catch (err) {
        this.showError(err);
      }
    },

    cancel() {
      this.$emit("on-cancel");
    }
  },
});
